export const externalPaymentRouter = [
  {
    path: "/projectPayment/externalPayment/list",
    name: "external-payment-list",
    meta: { title: "对外付款单" },
    component: () =>
      import(/* webpackChunkName: "externalPayment" */ "@/views/project-payment/externalPayment/list/index.vue"),
  },
  {
    hidden: true,
    path: "/projectPayment/externalPayment/create",
    name: "external-payment-createform",
    meta: { title: "新增对外付款单",comName:"projectPaymentExternalPaymentFormCreate" },
    component: () =>
      import(/* webpackChunkName: "externalPayment" */ "@/views/project-payment/externalPayment/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/projectPayment/externalPayment/edit/:id",
    name: "external-payment-editform",
    meta: { title: "编辑对外付款单",comName:"projectPaymentExternalPaymentFormCreate" },
    component: () =>
      import(/* webpackChunkName: "externalPayment" */ "@/views/project-payment/externalPayment/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/projectPayment/externalPayment/detail/:id",
    name: "external-payment-profile-form-detail",
    meta: { title: "对外付款单详情" },
    component: () =>
      import(
        /* webpackChunkName: "externalPayment" */ "@/views/project-payment/externalPayment/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/projectPayment/externalPayment/flowPrint/:id",
    name: "external-payment-profile-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "externalPayment" */ "@/views/project-payment/externalPayment/flow-print/index.vue"
      ),
  },
];
